//import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FMPSelect from '../pureForm/FMPSelect';
import _ from 'lodash';
import moment from 'moment';

function getMonthYearOption(monthYearMoment) {
	return {
		value: monthYearMoment.format('YYYY-MM'),
		display: monthYearMoment.format('MMMM, YYYY'),
	};
}

const monthYearOptions = [];
_.range(0, 16).forEach((i) => {
	if (moment().subtract(i, 'months').isBefore(moment('2020-04'))) {
		return;
	}
	monthYearOptions.push(getMonthYearOption(moment().subtract(i, 'months')));
});

const monthYearAndFutureOptions = [];
const startAt = moment().add(15, 'months');
_.range(0, 35).forEach((i) => {
	monthYearAndFutureOptions.push(getMonthYearOption(moment(startAt).subtract(i, 'months')));
});

class FMPMonthYearPicker extends PureComponent {
	render() {
		const { label, value, path, onChange, error, helpText, md, disabled, showFuture } = this.props;

		return (
			<FMPSelect
				label={label}
				path={path}
				value={value}
				error={error}
				options={showFuture ? monthYearAndFutureOptions : monthYearOptions}
				onChange={onChange}
				md={md}
				helpText={helpText}
				contained={false}
				disabled={disabled}
			/>
		);
	}
}

FMPMonthYearPicker.propTypes = {
	label: PropTypes.string,
	value: PropTypes.string.isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	classes: PropTypes.object,
	md: PropTypes.number,
	helpText: PropTypes.string,
	disabled: PropTypes.bool,
	showFuture: PropTypes.bool,
};

FMPMonthYearPicker.defaultProps = {
	md: 12,
	label: 'Month / Year',
};

export default FMPMonthYearPicker;
